import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CarinaCheck from 'common/icons/CarinaCheck';
import { GuestBrandedDefaultColors } from '../constants';

// This component is for Guest side usage (should not be used in Host side pages). It's a styled component to look like
// Carina components.
// NOTE: This component could be further improved by using styled-component or Radix-ui
const GuestBrandedSwitch = ({ id, value = false, onUpdate, isDisabled = false }) => {
    const borderColor = `var(--guest-branded-textHover, ${GuestBrandedDefaultColors.textHover})`;
    const primaryColor = `var(--guest-branded-action, ${GuestBrandedDefaultColors.action})`;
    const thumbOff = `var(--guest-branded-text, ${GuestBrandedDefaultColors.text})`;
    const thumbOn = `var(--guest-branded-actionText, ${GuestBrandedDefaultColors.actionText})`;

    const handleToggle = () => {
        if (!isDisabled && typeof onUpdate === 'function') {
            onUpdate(!value);
        }
    };

    const [isFocused, setIsFocused] = useState(false);
    const [isFocusVisible, setIsFocusVisible] = useState(false);

    const handleFocus = (e) => {
        // Only show outline if focus came from keyboard, not mouse
        if (e.target.matches(':focus-visible')) {
            setIsFocusVisible(true);
        }
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
        setIsFocusVisible(false);
    };

    const styles = {
        button: {
            all: 'unset',
            display: 'inline-block',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
        },

        track: {
            display: 'inline-block',
            position: 'relative',
            width: '40px',
            height: '24px',
            borderRadius: '9999px',
            border: value ? '0' : `2px solid ${borderColor}`,
            backgroundColor: value ? primaryColor : 'transparent',
            boxSizing: 'border-box',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.4 : 1,
            outline: isFocusVisible && isFocused ? `2px solid ${primaryColor}` : 'none',
            transition: 'background-color 400ms ease, opacity 200ms ease',
            verticalAlign: 'middle',
        },

        thumb: {
            position: 'absolute',
            top: value ? '2px' : '3px',
            left: value ? '-2px' : '3px',
            width: value ? '20px' : '14px',
            height: value ? '20px' : '14px',
            borderRadius: '0.75rem',
            backgroundColor: value ? thumbOn : thumbOff,
            transform: value ? 'translateX(100%)' : 'translateX(0)',
            boxShadow: value ? '0 0 2px rgba(0,0,0,0.2)' : 'none',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            willChange: 'transform',
            backfaceVisibility: 'hidden',
            transition: 'transform 200ms cubic-bezier(0.2, 0, 1, 0.9), background-color 150ms ease',
        },
    };

    return (
        <button
            id={id}
            aria-label={id}
            type="button"
            aria-checked={value}
            onClick={handleToggle}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={isDisabled}
            style={styles.button}
        >
            <div style={styles.track}>
                <div style={styles.thumb}>
                    {value && <CarinaCheck width={16} height={16} fill={primaryColor} aria-hidden="true" />}
                </div>
            </div>
        </button>
    );
};

GuestBrandedSwitch.propTypes = {
    id: PropTypes.string,
    value: PropTypes.bool,
    onUpdate: PropTypes.func,
    isDisabled: PropTypes.bool,
};

export default GuestBrandedSwitch;
